<template>
    <div class="top">
        <button type="button" class="offcanvas_close" @click="editContactClick">
            <fa :icon="['fal', 'chevron-right']" class="text-gray-200 text-2xl hidden lg:!block"/>
            <fa :icon="['fal', 'chevron-left']" class="text-gray-200 text-2xl lg:hidden"/>
        </button>
    </div>
</template>

<script setup>
import useToggleModal from "@/composables/useToggleModal";
const emits = defineEmits(['edit']);
const props = defineProps({
    isToggle: {
        type: Boolean,
        default: true
    }
})
const { toggleModal } = useToggleModal();
const editContactClick = () => {
    if (props.isToggle) {
        toggleModal();
    }
    emits('edit');
}
</script>

<style scoped>
.top {
    /* @apply lg:absolute top-3 md:bg-white dark:bg-dark-100 left-[-1.5rem] md:!w-6 lg:h-[3.5rem] flex items-center justify-center lg:border-r border-gray-100 md:rounded-l-lg md:rounded-r-none bg-gray-100 rounded-full lg:min-w-[1.5rem] min-w-[2rem] !w-8 h-8; */
    @apply lg:absolute top-3 md:bg-white dark:bg-dark-100 left-[-1.5rem] md:!w-6 lg:h-[3.5rem] flex items-center justify-center lg:border-r border-gray-100 dark:border-black-600 md:rounded-l-lg md:rounded-r-none bg-gray-100 rounded-full lg:min-w-[1.5rem] min-w-[2rem] !w-8 h-8;

}
.top.large{
    @apply lg:absolute md:static md:bg-white md:w-6 lg:h-[3.5rem] bg-gray-100 rounded-full !w-8 h-8; 
}
.top svg{
    @apply md:text-2xl text-base
}

/* .offcanvas_close {
    @apply text-2xlflex dark:text-black-900;
} */
</style>
